<template>
  <div class="intro__component">
    <div class="container__fw">
      <div class="full intro">
        <div class="photo">
          <div class="photo__portrait">
            <img class="upper" src="@/assets/photo_2.jpg" alt />
            <img class="lower" src="@/assets/rectangle_1.svg" alt />
          </div>
        </div>
        <div class="content">
          <div class="about__me">
            <h1 class="heading">Hi, I'm Nirvan</h1>
            <p class="descrp">
              You may call me Tejas. I research, architect & build systems,
              spearhead technology projects, and manage teams. I'm based in
              Mauritius
              <img class="mauritius" src="@/assets/mauritius.svg" alt="" />, a
              beautiful island in the Indian Ocean.
            </p>

            <p class="descrp">
              By passion, I'm a geeky experimental photographer and tinkerer. I
              <a target="_blank" href="https://twitter.com/nirvanpagooah"
                >tweet</a
              >
              & post my best shots on
              <a target="_blank" href="https://instagram.com/nirvanpagooah"
                >Instagram</a
              >.
            </p>

            <p class="descrp">
              <a
                class="read__more"
                target="_blank"
                href="https://www.linkedin.com/in/tejaspagooah/"
                >Read more &xrarr;</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.intro {
  max-width: 1400px;
  padding: 0 15px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: var(--gutter);
  grid-gap: 20px;

  .photo {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .photo__portrait {
      img {
        width: 100%;
        max-width: 550px;
        border-radius: 7px;
        box-shadow: 15px 15px 35px rgba(0, 0, 0, 0.3);
        position: relative;
      }

      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;

      .upper,
      .lower {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
      }

      .upper {
        z-index: 2;
      }

      .lower {
        z-index: 1;
        transform: translateX(30px) translateY(30px);
        box-shadow: 15px 15px 35px rgba(0, 87, 255, 0.5);
      }
    }
  }

  .content {
    text-align: left;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: var(--color-text-dark);

    .heading {
      font-size: 70px;
      font-weight: 700;
      margin: 0;
      letter-spacing: -1px;
    }

    .descrp {
      font-size: 28px;
      line-height: 42px;
      font-family: var(--font-noto);
      font-weight: 300;
      letter-spacing: -0.8px;

      .mauritius {
        height: 25px;
        border-radius: 4px;
        position: relative;
        top: 2px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      a {
        text-decoration: none;
        color: var(--color-blue);
        padding-bottom: 3px;
        border-bottom: 1px solid var(--color-blue);

        &.read__more {
          font-weight: 500;
          border-bottom: 0;
        }
      }

      .featured {
        color: var(--color-blue);
      }
    }
  }
}

@media (max-width: 1350px) {
  .intro {
    grid-gap: 40px;

    .photo {
      justify-content: center;

      .photo__portrait {
        img {
          max-width: 470px;
        }
      }
    }

    .content {
      .heading {
        font-size: 60px;
      }

      .descrp {
        font-size: 25px;
        line-height: 38px;
      }
    }
  }
}

@media (max-width: 1024px) {
  .intro {
    grid-gap: 60px;

    .photo {
      .photo__portrait {
        img {
          max-width: 400px;
        }
      }
    }

    .content {
      .heading {
        font-size: 55px;
      }

      .descrp {
        font-size: 23px;
        line-height: 35px;
      }
    }
  }
}

@media (max-width: 768px) {
  .intro {
    grid-template-columns: 1fr;
    grid-gap: 50px;

    .photo {
      .photo__portrait {
        img {
          max-width: 300px;
        }

        .lower {
          transform: translateX(23px) translateY(19px);
        }
      }
    }

    .content {
      .heading {
        font-size: 50px;
        text-align: center;
      }

      .descrp {
        font-size: 23px;
        line-height: 35px;
      }
    }
  }
}

@media (max-width: 500px) {
  .intro {
    .content {
      .heading {
        font-size: 40px;
      }

      .descrp {
        font-size: 21px;
        line-height: 33px;
      }
    }
  }
}
</style>
